"use strict";

($dt => {
	
	$dt.blocks['dropdown-container'] = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			// We only want stuff to happen in this block that is specific to this container, but otherwise
			// this block we want to setup using `ManualGlobalBlockSetup` because it will make it easier to ensure
			// nesting works correctly

			// Have to be careful not to select anything beyond the most immediate collapsed element in this block
			// because this block can be nested within itself
			const items = [];

			// Foreach row
			for (let i = 0; i < container.children.length; i++) {
				const item = {
					row_elem: container.children[i],
					collapsed_elem: container.children[i].children[0].children[0].children[0].children[0],
					expanded_elem: container.children[i].children[0].children[0].children[0].children[1],
					expanded: false
				};
				items.push(item);
			}

			items.forEach(item => {
				const { collapsed_elem, expanded_elem } = item;
				item.expanded = collapsed_elem.classList.contains('active');

				collapsed_elem.addEventListener('click', () => {
					if (item.expanded) {
						expanded_elem.classList.remove('expanded');
						collapsed_elem.classList.remove('active');
						item.expanded = false;
					} else {
						expanded_elem.classList.add('expanded');
						collapsed_elem.classList.add('active');
						item.expanded = true;
					}
				});
			});
		}
		
	};

})(window.d3_wp_themejs);
